import React from "react";
import { Container, Row, Col, Image, Collapse } from "react-bootstrap";
import ScrollAnimation from "react-animate-on-scroll";
import dev1 from "../../../images/workflowAutomation/business_process.png";
import dev2 from "../../../images/workflowAutomation/case-study.png";
import dev3 from "../../../images/workflowAutomation/decision-making.png";
import dev4 from "../../../images/workflowAutomation/analytics.png";
import dev5 from "../../../images/workflowAutomation/shield.png";
import dev6 from "../../../images/workflowAutomation/it.png";

import { AnimatedLine } from "../../common/designParts/animatedUnderline";
import { useViewport } from "../../common/designParts/useViewport";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import ServiceCard from "../../common/designParts/serviceCardComponent";

export const WorkflowServices = () => {
  const { width } = useViewport();
  const breakpoint = 768;
  const [open, setOpen] = useState(false);
  const [openservice, setOpenservice] = useState(false);
  return (
    <div>
      <div id="workflowservice"></div>
      <div className="mbg-img">
        <Container
          className="mcontainerpadding "
          style={{ background: "none" }}
        >
          <Row>
            <Col md={12}>
              <ScrollAnimation
                animateIn="animate-text"
                duration={5}
                animateOnce={true}
              >
                <h2 className="h2heading1">
                  Our Automation <span className="bold"> Services</span>
                </h2>
              </ScrollAnimation>

              <AnimatedLine
                className="animateline"
                width={"150px"}
                margin={"-5px 0"}
              >
                <ScrollAnimation
                  animateIn="fadeInLeft"
                  duration={2}
                  animateOnce={true}
                  className="no-animation"
                >
                  <div className="line"></div>
                </ScrollAnimation>
              </AnimatedLine>
            </Col>
          </Row>
          <br />

          <Row>
            <Col md={6} lg={4}>
              <ScrollAnimation
                animateIn="fadeIn"
                duration={2}
                animateOnce={true}
              >
                <div className="card digicard">
                  <div className="portal-service-img">
                    <Image src={dev1} className="serveimg" />
                  </div>
                  <p className="devheading"><span className="bold">Business Process Management</span></p>
                  <p className="devparagraph">
                    We identify the goal of the business process and identify
                    how to improve existing processes rather than carry the same
                    set of flows repeatedly.
                  </p>
                </div>
              </ScrollAnimation>
            </Col>
            <Col md={6} lg={4}>
              <ServiceCard
                id="collapse-services-dtl"
                heading="Case Management"
                image={dev2}
                content="We work to improve a business’s performance by understanding all related case information ahead of the process itself."
              />
            </Col>
            <Col md={6} lg={4}>
              <ServiceCard
                id="collapse-service-dtl2"
                heading="Business Decision Management"
                image={dev3}
                content="We gathers required data or references needed to make effective and consistent decisions. We help you decide whether to move forward with projects based on relevant data. "
              />
            </Col>

            <Collapse
              in={width < breakpoint ? open : true}
              className="collapse-div"
            >
              <div id="collapse-services-learning">
                <Col md={6} lg={4}>
                  <ServiceCard
                    id="collapse-service-dtl3"
                    heading="Reports & Analytics"
                    image={dev4}
                    content="Custom dashboards and reports will provide you with key insights into workflow processes."
                  />
                </Col>

                <Col md={6} lg={4}>
                  <ServiceCard
                    id="collapse-service-dtl5"
                    heading="Access Control and Security"
                    image={dev5}
                    content="Based on the user’s role, level, and form data type, define responsibilities and visibility.
                    "
                  />
                </Col>
                <Col md={6} lg={4}>
                  <ServiceCard
                    id="collapse-service-dtl4"
                    heading="Integration with API"
                    image={dev6}
                    content="We work with APIs that allow you to automate your workflows instantly, so you can reap the full benefits of automation."
                  />
                </Col>
              </div>
            </Collapse>
            <button
              onClick={() => setOpen(!open)}
              aria-controls="collapse-services-learning"
              aria-expanded={open}
              className="d-xl-none d-lg-none d-md-none collapse-btn text-center mr-auto ml-auto pt-2"
            >
              {open ? (
                ""
              ) : (
                <>
                  <span className="expand readmore">
                    Expand More <FontAwesomeIcon icon="angle-double-right" />
                  </span>
                </>
              )}
            </button>
          </Row>
        </Container>
      </div>
    </div>
  );
};
